import controller from './page.controller';
import templateBase from './templates/page-base.view.html';


let LoginComponent = {
  template : changeTemplate,
  controller,
  bindings : {
    shCtrl : '<',
    rPass:'@'
  }
};


changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
//   let response = SessionService.get('components');
//   if(__env.adaptative){
//     return templateAD;
//   } else {
//     if(response.LOGIN.component == 'template_t1'){
      // return templateT1;
   //  }else{
      return templateBase;
   //  }
//   }
}

export default LoginComponent;



// WEBPACK FOOTER //
// ./www/components/page/page.component.js